import { useContext } from 'react'
import { PendingAgreementsContext } from 'contexts/pendingAgreementsContext'

export const usePendingAgreementsContext = () => {
  return useContext(PendingAgreementsContext)
}
